import { TraceLevel } from './buls/TraceLevel';
import { LogCategory } from './buls/LogCategory';
/**
 * A logger that prints to browser's console
 */
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger() {
    }
    ConsoleLogger.tagIntToString = function (tag) {
        // Implementation based on %SRCROOT%\toolsrc\DTUtil\DTUtil\TagUtils.cs
        if (tag <= ConsoleLogger.maxNumericTag) {
            return tag.toString();
        }
        if (tag >> 24 >= this.minOldSchemeHighByteValue) {
            // Old format
            return String.fromCharCode((tag >> 24) & 0xff, (tag >> 16) & 0xff, (tag >> 8) & 0xff, tag & 0xff);
        }
        // New format
        return (ConsoleLogger.map.charAt((tag >> 24) & 0x3f) +
            ConsoleLogger.map.charAt((tag >> 18) & 0x3f) +
            ConsoleLogger.map.charAt((tag >> 12) & 0x3f) +
            ConsoleLogger.map.charAt((tag >> 6) & 0x3f) +
            ConsoleLogger.map.charAt(tag & 0x3f));
    };
    ConsoleLogger.getLogMessage = function (tag, category, message) {
        // LogCategory[category] gets us the name instead of the value
        return "tag_" + ConsoleLogger.tagIntToString(tag) + " [" + LogCategory[category] + "] " + message;
    };
    ConsoleLogger.prototype.sendTraceTag = function (tag, category, level, message) {
        var logFunc = console.log;
        switch (level) {
            case TraceLevel.Error:
                logFunc = console.error;
                break;
            case TraceLevel.Warning:
                logFunc = console.warn;
                break;
            case TraceLevel.Info:
                logFunc = console.info;
                break;
            case TraceLevel.Verbose:
                logFunc = console.debug;
                break;
            case TraceLevel.Spam:
            default:
                logFunc = console.log;
                break;
        }
        try {
            logFunc(ConsoleLogger.getLogMessage(tag, category, message));
        }
        catch (e) {
            var nav = typeof navigator !== 'undefined' ? navigator : undefined;
            // If we get here and are not IE, this is unexpected, throw.
            // IE11 has some issues with console, just catch it and continue
            if (nav && !/rv:11.0/i.test(nav.userAgent)) {
                throw e;
            }
        }
    };
    ConsoleLogger.prototype.shipAssertTag = function (tag, category, condition, message) {
        console.assert(condition, ConsoleLogger.getLogMessage(tag, category, message));
    };
    ConsoleLogger.prototype.debugAssertTag = function (tag, category, condition, message) {
        // Check if we're in debug mode
        this.shipAssertTag(tag, category, condition, message);
    };
    ConsoleLogger.maxNumericTag = 0x0000ffff;
    ConsoleLogger.minOldSchemeHighByteValue = 36;
    ConsoleLogger.map = 'abcdefghijklmnopqrstuvwxyz0123456789';
    return ConsoleLogger;
}());
export { ConsoleLogger };
//# sourceMappingURL=ConsoleLogger.js.map